import React, { useState } from 'react';
import './Table.css';
import Button from '../Button/Button';

const Table = ({ 
  columns, 
  data,
  currentPage = 1,
  totalItems = 0,
  itemsPerPage = 10,
  onPageChange,
  actionButtons = [],
  columnsShare = 0,
  headerBackground = 'var(--color-primary)',
  headerTextColor = 'var(--color-white)',
  tableHeight = "calc(85vh - 12rem)"
}) => {
  // Calculate total pages
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Handle page changes
  const handlePageChange = (page) => {
    if (onPageChange) {
      onPageChange(page);
    }
  };

  // Generate page numbers
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      }
    }
    return pages;
  };

  return (
    <div className="custom-table-container" style={{ height: tableHeight }}>
      <div className="table-header">
        <table className="custom-table">
          <colgroup>
            {/* Columnas principales */}
            {columns.filter(col => col.header !== '').map((column, index) => (
              <col key={index} style={{ 
                width: `${100 / columns.filter(col => col.header !== '').length}%`
              }} />
            ))}
            {/* Columnas de acciones */}
            {columns.filter(col => col.header === '').map((_, index) => (
              <col key={`action-${index}`} style={{ 
                width: columnsShare === 1 ? '100px' : '60px'
              }} />
            ))}
          </colgroup>
          <thead style={{ backgroundColor: headerBackground }}>
            <tr>
              {/* Columnas normales */}
              {columns.filter(col => col.header !== '').map((column, index) => (
                <th 
                  key={index}
                  style={{ 
                    color: headerTextColor, 
                    textAlign: 'center',
                    padding: '1rem 0.5rem'
                  }}
                >
                  {column.header}
                </th>
              ))}
              {/* Header de Actions */}
              {columnsShare > 0 && (
                <th 
                  colSpan={columnsShare}
                  style={{ 
                    color: headerTextColor, 
                    textAlign: 'center',
                    padding: '1rem 0.5rem'
                  }}
                >
                  Actions
                </th>
              )}
            </tr>
          </thead>
        </table>
      </div>
      <div className="table-wrapper">
        <table className="custom-table">
          <colgroup>
            {columns.map((column, index) => (
              <col key={index} style={{ 
                width: column.header === '' 
                  ? (columnsShare === 1 ? '100px' : '60px')
                  : `${100 / (columns.length - columnsShare)}%`
              }} />
            ))}
            {actionButtons.length > 0 && <col style={{ width: 'auto' }} />}
          </colgroup>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={columns.length + (columnsShare > 0 ? 1 : 0)} style={{ textAlign: 'center', padding: '1rem' }}>
                  No records found
                </td>
              </tr>
            ) : (
              data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {/* Columnas normales */}
                {columns.filter(col => col.header !== '').map((column, colIndex) => (
                  <td 
                    key={colIndex} 
                    style={{ 
                      textAlign: 'center'
                    }}
                  >
                    {column.render ? column.render(row) : row[column.field]}
                  </td>
                ))}
                {/* Columnas de acciones */}
                {columns.filter(col => col.header === '').map((column, colIndex) => (
                  <td 
                    key={`action-${colIndex}`}
                    className="action-cell"
                    style={{ 
                      textAlign: 'center',
                      width: '60px',
                      padding: '0.5rem',
                      verticalAlign: 'middle'
                    }}
                  >
                    <div style={{ 
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      {column.render ? column.render(row) : row[column.field]}
                    </div>
                  </td>
                ))}
              </tr>
            )))
            }
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          {getPageNumbers().map((page, index) => (
            <React.Fragment key={index}>
              {page === '...' ? (
                <span className="ellipsis">...</span>
              ) : (
                <button
                  className={`page-button ${currentPage === page ? 'active' : ''}`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              )}
            </React.Fragment>
          ))}
          <span className="results-text">{totalItems} | Results</span>
        </div>
      )}
    </div>
  );
};

export default Table;
